import { useWindowSize } from "@react-hookz/web";
import { useCallback, useMemo, useState, useEffect } from "react";
import {
  isMobile as mobileDevice,
  isTablet as tabletDevice,
  isDesktop as desktopDevice,
  useMobileOrientation,
} from "react-device-detect";
import { theme } from "../styles/theme";

const useResponsive = () => {
  const { width } = useWindowSize();
  const [orientation, setOrientation] = useState("");
  const { isLandscape, isPortrait } = useMobileOrientation();

  const [mobile, tabletSm, tablet, desktopSm, desktop] = theme.breakpoints;

  const isMobile = useMemo(
    () => width <= mobile.replace("px", ""),
    [mobile, width],
  );

  const isTabletSm = useMemo(
    () =>
      width > mobile.replace("px", "") && width <= tabletSm.replace("px", ""),
    [mobile, tabletSm, width],
  );
  const isTabletLg = useMemo(
    () =>
      width > tabletSm.replace("px", "") && width <= tablet.replace("px", ""),
    [tabletSm, tablet, width],
  );
  const isTablet = useMemo(
    () => width > mobile.replace("px", "") && width <= tablet.replace("px", ""),
    [mobile, tablet, width],
  );

  const isDesktopSm = useMemo(
    () =>
      width > tablet.replace("px", "") && width <= desktopSm.replace("px", ""),
    [tablet, desktopSm, width],
  );
  const isDesktopLg = useMemo(
    () =>
      width > desktopSm.replace("px", "") && width <= desktop.replace("px", ""),
    [desktopSm, desktop, width],
  );
  const isDesktopXl = useMemo(
    () => width > desktop.replace("px", ""),
    [desktop, width],
  );
  const isDesktop = useMemo(
    () => width > tablet.replace("px", ""),
    [tablet, width],
  );

  // receives an ordered array of values and returns according to the current breakpoint
  const breakpoint = useCallback(
    ([mobile, tablet, desktop]) => {
      if (isMobile) return mobile;
      if (isTablet) return tablet;
      return desktop ? desktop : tablet;
    },
    [isMobile, isTablet],
  );

  // Check if device is in Portrait mode or Landscape mode
  useEffect(() => {
    if (isLandscape) setOrientation("landscape");
    if (isPortrait) setOrientation("portrait");
  }, [isLandscape, isPortrait]);

  return {
    //vp width based breakpoints
    isMobile,
    isTabletSm,
    isTabletLg,
    isTablet,
    isDesktopSm,
    isDesktopLg,
    isDesktopXl,
    isDesktop,
    breakpoints: { mobile, tabletSm, tablet, desktopSm, desktop },
    //device type breakpoints
    type: {
      mobile: mobileDevice,
      tablet: tabletDevice,
      desktop: desktopDevice,
    },
    //utils
    breakpoint,
    orientation,
  };
};

export default useResponsive;
